import {useQuery} from '@apollo/react-hooks';

import {makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {GetMcfxCompany as GetMcfxCompanyQuery} from 'nutshell-graphql-types';

import GET_MCFX_COMPANY from '../queries/get-mcfx-company.graphql';

export const useGetMcfxCompany = (visitorId: string) => {
    const {data, loading: isLoading} = useQuery<GetMcfxCompanyQuery, Record<any, any>>(
        GET_MCFX_COMPANY,
        {
            variables: {
                id: visitorId,
            },
        }
    );

    const {mcfxCompany} = makeDataDangerous(data);

    return {mcfxCompany, isLoading};
};
